import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import authHeader from '../helpers/auth-header';
import { environment } from 'src/environments/environment';
import { MarketingSource } from '../interfaces/MarketingSource/marketing-source';


@Injectable({
  providedIn: 'root'
})
export class MarketingSourceService {

  constructor(private http: HttpClient) { }

  getMarketingSources(role: string): Observable<MarketingSource[]> {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': authHeader()
      }
    };
    let url: string = `${environment.APP_API_URL}/api/v1/MarketingSource/display/${role}`;
    if (role === 'marketing') {
      url = `${environment.APP_API_URL}/api/v1/MarketingSource/preview`;
    }

    return this.http.get(url, config)
      .pipe(
        map((response: any) => {
          return response as MarketingSource[];
        }),
        catchError(error => {
          console.error(error);
          return of([]);
        })
      );
  }
}
